import React from 'react';

const InvoiceGraph = (props) => {
  const { height, width, context, billDate, billAmount, billUrl, isMobileOrWeb, backGroundColor, textColor, mainAmount, subAmount, index } = props;
  let amount = parseFloat(mainAmount);
  // invoice amount for negative amount use
  let absAmount = Math.abs(amount);
  let flagMinus = false;
  if (amount < 0) {//flag=> negative amount found
    flagMinus = true;
  }
  //method to convert date format
  const dateMonth = () => {
    let day = billDate.charAt(0) + billDate.charAt(1);
    let year = billDate.charAt(6) + billDate.charAt(7);
    let month = billDate.charAt(3) + billDate.charAt(4);
    let newMonth = '';
    if (month === '01') newMonth = 'ינו';
    else if (month === '02') newMonth = 'פבר';
    else if (month === '03') newMonth = 'מרץ';
    else if (month === '04') newMonth = 'אפר';
    else if (month === '05') newMonth = 'מאי';
    else if (month === '06') newMonth = 'יונ';
    else if (month === '07') newMonth = 'יול';
    else if (month === '08') newMonth = 'אוג';
    else if (month === '09') newMonth = 'ספט';
    else if (month === '10') newMonth = 'אוק';
    else if (month === '11') newMonth = 'נוב';
    else if (month === '12') newMonth = 'דצמ';

    let date = day + ' ' + newMonth + ' ' + year;
    return date;
  };
  let currDate = dateMonth();

  if (!isMobileOrWeb) {
    return (
      <div className='graphBox'>
        <label className='graphBox' style={{ height: props.height + 'px', color: props.textColor, backgroundColor: props.backGroundColor }}
          onClick={() => props.openInvoiceOnlineIFrame(props.billUrl, props.invoiceSourceType, props.previous)}
        >
          <div>
            <span style={{ fontSize: "18px" }}>{subAmount}</span>
          </div>
          <div>
            <sup className='supDesign'>.</sup>
          </div>
          <div>
            <b>{absAmount}</b>
            {flagMinus && '-'}
          </div>
          <span style={{ fontSize: "22px", marginBottom: "3px" }}>&#8362;</span>
        </label>
      </div>
    );
  } else if (isMobileOrWeb && props.height !== 12) {//invoice amount not 0
    return (
      <div className='invoiceGraphMobile'>
        <label onClick={() => props.openInvoiceOnlineIFrame(props.billUrl, props.invoiceSourceType, props.previous)}
          className='invoiceMobileGraphBox'
          style={{ height: props.height + 'px', color: props.textColor, backgroundColor: props.backGroundColor }}>
          <div className='MobileGraphPrice'>
            <div className='MobileGraphPrice_internal'>
              <span className='supDesign'>{subAmount}</span>
              <span>.</span>
              <div className='mainAmount'>
                <b >{absAmount}</b>
                {flagMinus && '-'}
              </div>
              <div className='nis'>&#8362;</div>
              <div className='MobileGraphUrl'>
                {props.index == 0 && (
                  <div className='invoiceGraphMobile_Mobile_billDate_WhiteFirst' onClick={() => props.openInvoiceOnlineIFrame(props.billUrl, props.invoiceSourceType, props.previous)}
                  >
                    {currDate}
                  </div>
                )}
                {props.index != 0 && (
                  <a className='invoiceGraphMobile_Mobile_billDate' onClick={() => props.openInvoiceOnlineIFrame(props.billUrl, props.invoiceSourceType, props.previous)}
                  >
                    {currDate}
                  </a>
                )}
              </div>
            </div>
          </div>
        </label>
      </div>
    );
  } else if (isMobileOrWeb && props.height == 12) {//invoice amount  0
    return (
      <div className='invoiceGraphMobile-zero'>
        <div style={{ marginTop: "44px" }}>
          <div className='MobileGraph-zero-Price'>
            <div className='MobileGraphPrice_internal'>
              <span className='supDesign' style={{ top: "0" }}>{subAmount}</span>
              <span>.</span>
              <div className='mainAmount'>
                <b style={{ fontSize: "28px" }}>{mainAmount}</b>
              </div>
              <div className='nis'>&#8362;</div>
            </div>
          </div>
          <div className='MobileGraphUrl-zero'>
            {props.index == 0 && (
              <div
                className='invoiceGraphMobile_Mobile_billDate_WhiteFirst'
                onClick={() => props.openInvoiceOnlineIFrame(props.billUrl, props.invoiceSourceType, props.previous)}
                style={{ color: '#000' }}
              >
                {currDate}
              </div>
            )}
            {props.index != 0 && (
              <div className='invoiceGraphMobile_Mobile_billDate'
                onClick={() => props.openInvoiceOnlineIFrame(props.billUrl, props.invoiceSourceType, props.previous)}
              >
                {currDate}
              </div>
            )}
          </div>
          <label
            onClick={() => props.openInvoiceOnlineIFrame(props.billUrl, props.invoiceSourceType, props.previous)}
            className='invoice-zero-MobileGraphBox'
            style={{ height: props.height + 'px', color: props.textColor, backgroundColor: props.backGroundColor }}></label>
        </div>
      </div>
    );
  }
};

export default InvoiceGraph;
